import { render, staticRenderFns } from "./AutocreditBankDetails.vue?vue&type=template&id=24e6e5ea&scoped=true&"
import script from "./AutocreditBankDetails.vue?vue&type=script&lang=ts&"
export * from "./AutocreditBankDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e6e5ea",
  null
  
)

export default component.exports